import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const LOADING = 'loading'
export const APPLY = 'apply'
export const CANCEL = 'cancel'
export const SAVE_SETTINGS = 'save settings'
export const PAUSE_SAMPLE = 'pause sample'
export const LAUNCH_SAMPLE = 'launch sample'
export const CHANGES_SAVED = 'changes saved'
export const LAUNCHING = 'launching'
export const MODAL_SAVE = 'modal save'
export const PAUSE_SAMPLE_MESSAGE = 'pause sample message'
export const START_FIELD = 'start field'
export const SURVEY_UPDATED = 'survey updated'
export const WANT_DELETE = 'want delete'
export const SURVEY_LAUNCHED = 'survey launched'
export const SURVEY_PAUSED = 'survey paused'
export const VALIDATION_WANTED_COMPLETES = 'validation wanted completes'
export const VALIDATION_AGE_RANGE = 'validation age range'

export default {
  [PORTUGUESE]: {
    [LOADING]: 'Carregando',
    [APPLY]: 'Aplicar',
    [CANCEL]: 'Cancelar',
    [SAVE_SETTINGS]: 'Salvar Configurações',
    [PAUSE_SAMPLE]: 'Pausar Amostra',
    [LAUNCH_SAMPLE]: 'Começar Campo',
    [CHANGES_SAVED]: 'As mudanças foram salvas',
    [LAUNCHING]: 'Lançamento',
    [SURVEY_LAUNCHED]: 'Pesquisa lançada',
    [SURVEY_PAUSED]: 'Pesquisa pausada',
    [MODAL_SAVE]:
      'Ao pausar sua pesquisa, todas as respostas coletadas serão excluídas permanentemente. Antes de prosseguir, é altamente recomendável que você baixe todos os seus resultados na “Ferramenta de Relatórios”.',
    [PAUSE_SAMPLE_MESSAGE]: 'Tem certeza de que deseja pausar a sua amostra?',
    [START_FIELD]: 'Tem certeza de que está pronto para começar o campo?',
    [SURVEY_UPDATED]: 'Pesquisa atualizada',
    [WANT_DELETE]: 'Tem certeza de que deseja excluir?',
    [VALIDATION_WANTED_COMPLETES]:
      'O número de completas desejadas deve ser maior que "0"',
    [VALIDATION_AGE_RANGE]:
      'Os campos mínimo e máximo da faixa etária não podem ser menor que "13"',
  },

  [ENGLISH]: {
    [LOADING]: 'Loading',
    [APPLY]: 'Apply',
    [CANCEL]: 'Cancel',
    [SAVE_SETTINGS]: 'Save Settings',
    [PAUSE_SAMPLE]: 'Pause Sample',
    [LAUNCH_SAMPLE]: 'Launch Sample',
    [CHANGES_SAVED]: 'Changes have been saved',
    [LAUNCHING]: 'Launching',
    [SURVEY_LAUNCHED]: 'Survey launched',
    [SURVEY_PAUSED]: 'Survey paused',
    [MODAL_SAVE]:
      'By pausing your survey, all the answers you collected will be permanently deleted. Before moving forward, it is strongly advised that you download all your results in the “Reporting Tool”.',
    [PAUSE_SAMPLE_MESSAGE]: 'Are you sure you want to pause your sample?',
    [START_FIELD]: 'Are you sure you are ready to start field?',
    [SURVEY_UPDATED]: 'Survey updated',
    [WANT_DELETE]: 'Are you sure you want to delete?',
    [VALIDATION_WANTED_COMPLETES]: 'Number of wanted completes must be greater than "0"',
    [VALIDATION_AGE_RANGE]:
      'The age range minimum and maximum fields cannot be less than "13"',
  },

  [SPANISH]: {
    [LOADING]: 'Cargando',
    [APPLY]: 'Aplicar',
    [CANCEL]: 'Cancelar',
    [SAVE_SETTINGS]: 'Guardar Ajustes',
    [PAUSE_SAMPLE]: 'Pausar Muestra',
    [LAUNCH_SAMPLE]: 'Empezar Campo',
    [CHANGES_SAVED]: 'Los cambios han sido guardados',
    [LAUNCHING]: 'Lanzamiento',
    [SURVEY_LAUNCHED]: 'Encuesta lanzada',
    [SURVEY_PAUSED]: 'Encuesta en pausa',
    [MODAL_SAVE]:
      'Al pausar su encuesta, todas las respuestas que recopiló se eliminarán de forma permanente. Antes de seguir adelante, se recomienda encarecidamente que descargue todos sus resultados en la "Herramienta de informes".',
    [PAUSE_SAMPLE_MESSAGE]: '¿Estás seguro de que quieres pausar tu muestra?',
    [START_FIELD]: '¿Estás seguro de que estás listo para comenzar el campo?',
    [SURVEY_UPDATED]: 'Encuesta actualizada',
    [WANT_DELETE]: '¿Estás seguro de que quieres eliminar?',
    [VALIDATION_WANTED_COMPLETES]:
      'El número de búsquedas completas debe ser mayor que "0"',
    [VALIDATION_AGE_RANGE]:
      'Los campos mínimo y máximo del rango de edad no pueden ser menores a "13"',
  },
}
